import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FacturacionComponent } from './formulario/formulario.component';
import { DashboardFacturaComponent } from './dashboard/dashboard.component';
import { ListaComponent } from './lista/lista.component';
import { AuthGuard } from '../../auth-guard.service';

const routes: Routes = [
  {
    path: 'servicio-financiero/facturacion/factura',
    children: [
       { path: 'lista', component: ListaComponent},
       { path: 'nuevo', component: FacturacionComponent },
       { path: 'dashboard', component: DashboardFacturaComponent},
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class FacturacionRoutingModule { }

